import { ReadonlyVec3, vec2 } from 'gl-matrix';
import { atom } from 'recoil';
import { DoseSummationType, DoseType } from '~/domain/dicom/dicomDose';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { CurveData } from '~/domain/patient/dvh';
import {
    DEFAULT_DOSE_OPACITY_VALUE,
    DEFAULT_MIN_DOSE_RANGE,
    DEFAULT_MAX_DOSE_RANGE,
} from '~/engine/data/dose/DoseDistribution';
import { DoseTargetData } from '~/utils/transforms/doseTargetsTransforms';

export const doseVisibilityState = atom<boolean>({
    key: 'doseVisibilityState',
    default: true,
});

export const doseOpacityState = atom<number>({
    key: 'doseOpacityState',
    default: DEFAULT_DOSE_OPACITY_VALUE,
});

export const currentDoseState = atom<DoseMatrix | undefined>({
    key: 'currentDoseState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const doseDataState = atom<DoseViewData | undefined>({
    key: 'doseDataState',
    default: undefined,
});

export const dicomDvhCurvesState = atom<CurveData[]>({
    key: 'dicomDvhCurvesState',
    default: [],
});

export const selectedDoseRangeState = atom<vec2>({
    key: 'selectedDoseRangeState',
    default: vec2.fromValues(DEFAULT_MIN_DOSE_RANGE, DEFAULT_MAX_DOSE_RANGE),
});

export type DoseViewData = {
    id: string;
    sopUid: string;
    normalizationValueGy: number;
    doseScale: number;
    type: DoseType;
    summationType: DoseSummationType;
    doseGridResolution: ReadonlyVec3;
    planLabel?: string;
    generated: boolean;
    maxDoseGy: number;
    manufacturer: string;
    manufacturerModelName: string;
    seriesDescription: string;
    doseComment: string;
    softwareVersions: string;
    targets?: DoseTargetData[];
};
